angular.module('controllers').controller('mapController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window', 'Crud', '$filter', 'orderByFilter', '$mdDialog', 'Mqtt', '$compile', '$q',
    function ($scope, $rootScope, $controller, $route, $routeParams, $location, $timeout, $interval, $window, Crud, $filter, orderByFilter, $mdDialog, Mqtt, $compile, $q) {

        Mqtt.connect($rootScope.mq);

        $rootScope.path = '/slot';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'slot';
        $scope.pathTemplate = 'distribution/maps';
        $scope.title = 'Rute soferi';

        angular.extend($scope, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'slot_no';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'desc';
        $scope.classAction = 'td-big';
        $scope.additionals['publicAudioPath'] = '/audio';
        $scope.additionals['pathOrder'] = '/order';
        $scope.additionals['publicAppPath'] = '/images/app';
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['publicDriverPath'] = '/images/drivers';

        $scope.slot_status = [];
        $scope.slot_status.options = [
            {'id':'', 'value' : ''},
            {'id':1, 'value' : 'inchis'},
            {'id':0, 'value' : 'deschis'}
        ];

        $scope.orderStatus = {};
        $scope.orderStatus.options = [
            {'id':4, 'value' : 'Curs de livrare', 'color' : 'rgba(169, 215, 65, 0.9)', 'color-even' : 'rgba(169, 215, 65, 0.7)'},//green
            {'id':5, 'value' : 'Livrata', 'color' : 'rgba(0, 51, 153, 0.4)', 'color-even' : 'rgba(0, 51, 153, 0.2)'},//blue
            {'id':6, 'value' : 'Anulata sofer', 'color' : 'rgba(90, 87, 87, 0.8)', 'color-even' : 'rgba(90, 87, 87, 0.6)'}//black
        ];

        $scope.orderSource = {};
        $scope.orderSource.options = [
            {'id': '', 'value': ''},
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon': $scope.additionals['publicAppPath'] + '/phone.png'},
            {'id': 2, 'value': $rootScope.nameProject, 'icon': $scope.additionals['publicAppPath'] + '/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon': $scope.additionals['publicAppPath'] + '/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon': $scope.additionals['publicAppPath'] + '/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];

        $scope.additionals['order_status_string'] = JSON.stringify($scope.orderStatus.options);
        $scope.additionals['order_source_string'] = JSON.stringify($scope.orderSource.options);

        $scope.additionals['searchTermDriver'];
        $scope.additionals['clearSearchTermDriver'] = function() {
            $scope.additionals['searchTermDriver'] = '';
        };
        $scope.additionals['onSearchChangeDriver'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.additionals['searchTermDriverSingle'];
        $scope.additionals['clearSearchTermDriverSingle'] = function() {
            $scope.additionals['searchTermDriverSingle'] = '';
        };
        $scope.additionals['onSearchChangeDriverSingle'] = function(ev) {
            ev.stopPropagation();
        };

        var driver_point_object = [];
        $scope.color = '4ea2e7';//blue
        $scope.color_delivery = '78bf44';//green
        $scope.color_delivered = '7fa4be';//gray-blue
        $scope.color_undelivered = '717171';//gray
        $scope.color_driver = 'e7534e';//red
        $scope.state = {};
        $scope.state.view = 'drivers';
        $scope.driver_marker_object = {};
        $scope.driver_marker = {};
        $scope.color_drivers = {};
        $scope.markersEstimated = [];
        $scope.driver_points = [];
        $scope.routeReal = [];
        $scope.colors_drivers_array = ['1f1f1f', '4ea2e7', '4ee774', '7fa4be', '7fa970', '8b4ee7', '9a9a9a', '19e9ff', '78bf44', '363aff', '7091a9', '717171', '767676', 'a99470', 'b4e74e', 'dd62ff', 'e5f144', 'e7b14e', 'e7534e', 'f17044', 'ff3a36', 'ff36b5', 'ffb419', 'ffde62'];

        $rootScope.stopCheckOn = $interval(function () {
            Crud.get($scope.path + '/checkOn')
                .success(function (data) {

                    /* notifications */
                    if (angular.isUndefined(data['notifications'].length)) {
                        data['notifications'] = [data['notifications']];
                    }

                    var delete_notifications = [];
                    angular.forEach($scope.drivers_notifications, function (item, key) {
                        var positionNotification = data['notifications'].map(function (e) {
                            //if(e['driver_notification_closed'] == 0) {
                                return e['id'];
                            //}
                        }).indexOf(parseInt(item['id']));
                        if (positionNotification < 0) {
                            if (item['driver_notification_type'] == 2 || item['driver_notification_type'] == 3) {
                                delete_notifications[key] = item;
                            }
                        }
                    });

                    angular.forEach(delete_notifications, function (itemNot, keyNot) {
                        var positionNot = $scope.drivers_notifications.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(itemNot['id']));
                        if (positionNot >= 0) {
                            if ($scope.drivers_notifications[positionNot]['driver_notification_type'] == 2 || $scope.drivers_notifications[positionNot]['driver_notification_type'] == 3) {
                                $scope.controlDriverNotification[itemNot['driver_id']] = 0;

                                if (data['notifications'].length <= 0) {
                                    $scope.updateColorDriverMarker(itemNot['driver_id'], 0);
                                } else {
                                    $scope.updateColorDriverMarker(itemNot['driver_id'], itemNot['noOrdersUndeliveryByDriver']);
                                }
                                $scope.drivers_notifications.splice(positionNot, 1);
                            }
                        }
                    });

                    //angular.extend($scope.drivers_notifications, data['notifications']);
                    //$scope.drivers_notifications = [].concat($scope.drivers_notifications, data['notifications']);
                    angular.forEach(data['notifications'], function (itemNoti, keyNoti) {
                        if (itemNoti['driver_notification_type'] == 2 || itemNoti['driver_notification_type'] == 3) {
                            //$scope.drivers_notifications.push(itemNoti);
                            var position = $scope.drivers_notifications.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(itemNoti['id']));
                            if (position >= 0) {
                                $scope.drivers_notifications[position] = itemNoti;
                            } else {
                                $scope.drivers_notifications.push(itemNoti);
                            }
                            $scope.controlDriverNotification[itemNoti['driver_id']] = 1;
                            $scope.updateColorDriverMarker(itemNoti['driver_id'], itemNoti['noOrdersUndeliveryByDriver']);
                        }
                    });
                    /* end notifications */

                    /* update drivers */
                    angular.forEach(data['drivers'], function (itemDriver, keyDriver) {
                        if ($scope.state.view == 'routes') {

                            if ($scope.search['id'] == itemDriver[0].slot_id) {
                                if (!angular.isUndefined(itemDriver)) {
                                    if (!angular.isUndefined(itemDriver[1])) {
                                        if (!angular.isUndefined($scope.slotModel) && $scope.slotModel != null) {
                                            if(itemDriver[1].route_slot_start != null && itemDriver[1].route_slot_end == null) {
                                                $scope.controlDriver[itemDriver[1]['driver_id']] = 1;
                                            } else {
                                                $scope.controlDriver[itemDriver[1]['driver_id']] = 0;
                                            }
                                            $scope.addDriverMarker(itemDriver[1]['driver'], itemDriver[1]['driver_latitude'], itemDriver[1]['driver_longitude']);
                                            $scope.executed = false;

                                            if (!angular.isUndefined(itemDriver[0]['route_slot_start']) && itemDriver[0]['route_slot_start'] != null) {
                                                $scope.slotModel.route_slot_start = itemDriver[0]['route_slot_start'];
                                            }
                                            $scope.slotModel.route_slot_end = itemDriver[1]['route_slot_end'];
                                            $scope.routesControl.route_real = true;

                                            var model = {};
                                            model.id = itemDriver[0].slot_id;
                                            model.routes = itemDriver;
                                            $scope.loadRouteReal(model, null);

                                            if($scope.slotModel) {
                                                if (!angular.isUndefined(itemDriver[1]['route_slot_end']) && itemDriver[1]['route_slot_end'] != null) {
                                                    if (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap != null) {
                                                        $interval.cancel($rootScope.stopTimerSlotMap);
                                                    }
                                                } else {
                                                    if (angular.isUndefined($rootScope.stopTimerSlotMap) || $rootScope.stopTimerSlotMap == null || (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap.$$state.value == 'canceled')) {
                                                        $rootScope.stopTimerSlotMap = $interval(function () {
                                                            $scope.timerSlot();
                                                        }, 1000);
                                                    }
                                                    $scope.$apply();
                                                }
                                            }

                                        }
                                    } else {
                                        if(itemDriver[0].route_slot_start != null && itemDriver[0].route_slot_end == null) {
                                            $scope.controlDriver[itemDriver[0]['driver_id']] = 1;
                                        } else {
                                            $scope.controlDriver[itemDriver[0]['driver_id']] = 0;
                                        }
                                        $scope.addDriverMarker(itemDriver[0]['driver'], itemDriver[0]['driver_latitude'], itemDriver[0]['driver_longitude']);
                                        $scope.executed = false;
                                    }
                                }
                            }

                        } else {
                            if (!angular.isUndefined(itemDriver)) {
                                if (!angular.isUndefined(itemDriver[1])) {
                                    if(itemDriver[1].route_slot_start != null && itemDriver[1].route_slot_end == null) {
                                        $scope.controlDriver[itemDriver[1]['driver_id']] = 1;
                                    } else {
                                        $scope.controlDriver[itemDriver[1]['driver_id']] = 0;
                                        //$scope.map.removeLayer($scope.driver_marker[itemDriver[1]['driver_id']]);
                                    }
                                    $scope.addDriverMarker(itemDriver[1]['driver'], itemDriver[1]['driver_latitude'], itemDriver[1]['driver_longitude']);
                                    $scope.executed = false;

                                } else {

                                    if(itemDriver[0].route_slot_start != null && itemDriver[0].route_slot_end == null) {
                                        $scope.controlDriver[itemDriver[0]['driver_id']] = 1;
                                    } else {
                                        $scope.controlDriver[itemDriver[0]['driver_id']] = 0;
                                    }
                                    $scope.addDriverMarker(itemDriver[0]['driver'], itemDriver[0]['driver_latitude'], itemDriver[0]['driver_longitude']);
                                    $scope.executed = false;


                                }
                            }
                        }

                    });
                    /* end update drivers */

                    /* update drivers list */
                    if (angular.isUndefined(data['driversList']['drivers_f'].length)) {
                        data['driversList']['drivers_f'] = [data['driversList']['drivers_f']];
                    }
                    if (angular.isUndefined(data['driversList']['drivers_b'].length)) {
                        data['driversList']['drivers_b'] = [data['driversList']['drivers_b']];
                    }
                    $scope.additionals['drivers_f'] = data['driversList']['drivers_f'];
                    $scope.additionals['drivers_b'] = data['driversList']['drivers_b'];

                    //console.log($scope.additionals['drivers_f'])
                    /* end update drivers list */

                });
        }, 10000);

        $scope.getMarkersPositions = function () {
            Crud.get($scope.path + '/getMarkersPositions')
                .success(function (data) {
                    angular.forEach(data, function (item, key) {
                        if(item['noOrdersUndeliveryByDriver'] == 0) {
                            $scope.controlDriver[item['driver_id']] = 0;
                        }
                        if(item['noOrdersUndeliveryByDriver'] > 0) {
                            $scope.controlDriver[item['driver_id']] = 1;
                        }
                        $scope.addDriverMarker(item['driver'], item['driver_latitude'], item['driver_longitude'], item['noOrdersUndeliveryByDriver']);
                    });
                });
        };
        setTimeout(function() {
            $scope.getMarkersPositions();
        }, 700);

        $scope.controlDriver = {};
        $scope.controlDriverNotification = {};

        $scope.updateColorDriverMarker = function (driverId, noOrdersUndeliveryByDriver) {

            var colorDriver = '78bf44';
            if($scope.controlDriverNotification[driverId] == 1) { //driver notificated
                colorDriver = 'e7534e';
            } else {
                if($scope.controlDriver[driverId] == 0) { //driver free
                    colorDriver = '78bf44';
                }
                if($scope.controlDriver[driverId] == 1) { //driver busy
                    colorDriver = '1f1f1f';
                }
            }
            if (!angular.isUndefined($scope.driver_marker[driverId]) && $scope.driver_marker[driverId] != null) {
                var customIcon = L.divIcon({
                    className: 'driver-div-icon' + driverId,
                    html: '<div class="marker marker-div" style="background:url(\'..' + $scope.additionals['publicAppPath'] + '/map/marker_' + colorDriver + '.png\') no-repeat 0 100%"><div class="marker-label">'+noOrdersUndeliveryByDriver+'</div></div>',
                    popupAnchor: [0, -40]
                });
                $scope.driver_marker[driverId].setIcon(customIcon);
            }
        }

        $scope.removeDriver = function (driver_id) {

            if (!angular.isUndefined($scope.driver_marker[driver_id])) {
                $scope.driver_marker[driver_id].remove($scope.map);
                $scope.map.removeLayer($scope.driver_marker[driver_id]);
            }

            var position_f = $scope.additionals['drivers_f'].map(function (e) {
                return e['id'];
            }).indexOf(parseInt(driver_id));
            if (position_f >= 0) {
                 $scope.additionals['drivers_f'].splice(position_f, 1);
            }

            var position_b = $scope.additionals['drivers_b'].map(function (e) {
                return e['id'];
            }).indexOf(parseInt(driver_id));
            if (position_b >= 0) {
                $scope.additionals['drivers_b'].splice(position_b, 1);
            }
        }

        $scope.messageDispatcher = function (driver) {
            $scope.message_dispatcher = {};
            $scope.message_dispatcher['driver_id'] = driver['id'];
            $scope.message_dispatcher['driver_name'] = driver['driver_name'];
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'messageDispatcherDialog.tmpl.html',
                parent: angular.element(document.body),
                //targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    pathTemplate: $scope.pathTemplate,
                    path: $scope.path,
                    message_dispatcher: $scope.message_dispatcher
                }
            }).then(function () {

            });
            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'message_dispatcher'];
            function DialogController($scope, $mdDialog, pathTemplate, path, message_dispatcher, driver) {
                $scope.pathTemplate = pathTemplate;
                $scope.path = path;
                $scope.message_dispatcher = message_dispatcher;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.sendMessageDispatcher = function () {
                    var post = {};
                    post['route'] = 'store';
                    post['driver_id'] = $scope.message_dispatcher['driver_id'];
                    post['message'] = $scope.message_dispatcher['message_dispatcher'];

                    Crud.post('form-urlencoded', post, 'driver-message/store')
                        .success(function (data) {
                            $mdDialog.cancel();
                        });
                };
            }

        }

        $scope.addDriverMarker = function (driver, latitude, longitude, noOrdersUndeliveryByDriver) {

            var colorDriver = '78bf44';
            if($scope.controlDriverNotification[driver['id']] == 1) { //driver notificated
                colorDriver = 'e7534e';
            } else {
                if($scope.controlDriver[driver['id']] == 0) { //driver free
                    colorDriver = '78bf44';
                }
                if($scope.controlDriver[driver['id']] == 1) { //driver busy
                    colorDriver = '1f1f1f';
                }
            }
            //console.log($scope.controlDriver)
            //console.log($scope.controlDriverNotification)
            //console.log(colorDriver)

            var driver_popup = '';
            driver_popup = '<div class="red font18 margin-bottom-small text-center">' + driver['driver_name'] + '</div>';

            if (angular.isUndefined($scope.driver_marker[driver['id']]) || $scope.driver_marker[driver['id']] == null) {
                $scope.color_drivers[driver['id']] = $scope.colors_drivers_array[Object.keys($scope.driver_marker).length];
            }
            if ($scope.map) {
                //console.log(colorDriver)
                //console.log($scope.controlDriver)
                $scope.driver_marker_object[driver['id']] = L.marker(
                    [latitude, longitude],
                    {
                        id: driver['id'],
                        draggable: false,
                        opacity:1,
                        icon: L.divIcon({
                            //className: 'driver-div-icon',
                            //html: '<div class="marker marker-'+$scope.color_driver+'"></div>'
                            className: 'driver-div-icon' + driver['id'],
                            /* html: '<div class="marker marker-div" style="background:url(\'..' + $scope.additionals['publicAppPath'] + '/map/marker_' + $scope.color_drivers[driver['id']] + '.png\') no-repeat 0 100%"></div>',
                               // '<div class="marker-driver-div">' + $scope.additionals['drivers'][posDriver]['driver_name'] + '</div>',*/
                            html: '<div class="marker marker-div" style="background:url(\'..' + $scope.additionals['publicAppPath'] + '/map/marker_' + colorDriver + '.png\') no-repeat 0 100%"><div class="marker-label">'+noOrdersUndeliveryByDriver+'</div></div>',
                            popupAnchor: [0, -40]

                        })
                    });

                if (!angular.isUndefined($scope.driver_marker[driver['id']]) && $scope.driver_marker[driver['id']] != null && $scope.map.hasLayer($scope.driver_marker[driver['id']])) {
                    //$scope.map.removeLayer($scope.driver_marker);
                    $scope.driver_marker[driver['id']].setLatLng([latitude, longitude]);
                    $scope.driver_marker[driver['id']].setOpacity(1);
                    var customIcon = L.divIcon({
                        className: 'driver-div-icon' + driver['id'],
                        html: '<div class="marker marker-div" style="background:url(\'..' + $scope.additionals['publicAppPath'] + '/map/marker_' + colorDriver + '.png\') no-repeat 0 100%"><div class="marker-label">'+noOrdersUndeliveryByDriver+'</div></div>',
                        popupAnchor: [0, -40]
                    });
                    $scope.driver_marker[driver['id']].setIcon(customIcon);
                    $scope.driver_marker[driver['id']].openTooltip();

                } else {
                    $scope.driver_marker[driver['id']] = $scope.driver_marker_object[driver['id']].addTo($scope.map);/*.bindPopup(driver_popup, {
                        maxWidth: 140,
                        maxHeight: 80
                    });*/
                    $scope.driver_marker[driver['id']].bindTooltip(driver['driver_name'], {permanent:true, direction:'top', opacity:0.8}).openTooltip();

                    /*$scope.driver_marker[driver['id']] = $scope.driver_marker_object[driver['id']].addTo($scope.map);
                    $scope.driver_marker[driver['id']].bindPopup(null);
                    $scope.driver_marker[driver['id']].on('click', function(e) {
                        var marker_driver_div = document.getElementsByClassName('marker-driver-div');
                        marker_driver_div[0].style.opacity = 0;
                        $scope.driver_marker[driver['id']].setPopupContent(driver_popup);
                    });
                    $scope.driver_marker[driver['id']].getPopup().on('remove', function() {
                        var marker_driver_div = document.getElementsByClassName('marker-driver-div');
                        marker_driver_div[0].style.opacity = 1;
                    });*/

                }

                $scope.driver_marker[driver['id']].bindPopup(null);
                $scope.driver_marker[driver['id']].on('popupopen', function(e) {

                    $scope.driver_marker[driver['id']].closeTooltip();
                    if (!$scope.executed) {
                        $scope.executed = true;

                        /*var driver_popup_info = '';
                        driver_popup_info += '<div class="text-center">Tel. ' + driver['driver_phone'] + '</div>';
                        if (driver['car_no'] == 'undefined' || driver['car_no'] == 'null' || driver['car_no'] == null) {
                            driver['car_no'] = 'nedefinit';
                        }
                        driver_popup_info += '<div class="text-center">Nr. ' + driver['car_no'] + '</div>';

                        var driver_popup_orders_req = '';
                        var driver_popup_time_req = '';
                        $scope.driver_marker[driver['id']].setPopupContent(driver_popup + driver_popup_orders_req + driver_popup_info + driver_popup_time_req);*/

                        $scope.getInfoDriver(driver['id']).then(function(response) {
                            var getHour = response.stationaryTime.split(':');

                            var popup = $scope.driver_marker[driver['id']].getPopup();
                            var content = '<div><div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formMarkerDriver.html\'"></div></div>';
                            var _templateScope;
                            if (!_templateScope) {
                                _templateScope = $scope.$new();
                            }
                            _templateScope.driver = driver;
                            _templateScope.response = response;
                            _templateScope.getHour = getHour[0];
                            var compiled = $compile(content)(_templateScope);
                            var options = {
                                maxWidth: 200,
                                maxHeight: 110
                            };
                            popup.setContent(compiled[0]);

                            /*if(response.undeliveredOrders != '') {
                                driver_popup_orders_req += '<div class="text-center red">Comenzi de livrat: ' + response.undeliveredOrders + '</div>';
                            }
                            var getHour = response.stationaryTime.split(':');
                            if(getHour[0] == '01') {
                                driver_popup_time_req += '<div class="text-center">Stationare: > '+response.stationaryTime+ '</div>';
                            } else {
                                driver_popup_time_req += '<div class="text-center">Stationare: '+response.stationaryTime+ '</div>';
                            }
                            $scope.driver_marker[driver['id']].setPopupContent(driver_popup + driver_popup_orders_req + driver_popup_info + driver_popup_time_req);*/

                        });

                        setTimeout( function() {
                            $scope.executed = false;
                        }, 500);
                    }
                });
                $scope.driver_marker[driver['id']].on('popupclose', function(e) {
                    $scope.driver_marker[driver['id']].openTooltip();
                });
            }
        }

        $scope.getInfoDriver = function(driverId) {
            var deferred = $q.defer();
            Crud.get($scope.path + '/getInfoDriver?driver_id='+driverId)
                .success(function (data) {
                    deferred.resolve(data);
                }).error(function(data, status, headers, config) {
                    deferred.reject("Error: request returned status " + status);
                });
            return deferred.promise;
        }

        $scope.addDriverPoint = function(latitude, longitude, driver_date, position, color) {
            if($scope.map) {
                if (angular.isUndefined(driver_point_object)) {
                    driver_point_object = [];
                }

                var i = $scope.driver_points.length;
                var html = '';
                //console.log(i+'-'+$scope.dataRoute['routes'].length+'-'+$scope.end_point+'-'+$scope.offset)

                if (!angular.isUndefined(position) && position != null && position != 'null') {
                    if(position == 'start' && i == 0) {
                        var html = '<div class="marker-start"></div>';
                        var point_popup = '<h2 class="red text-center">Start:</h2>';
                    } else {
                        if(position == 'start') {
                          if (!angular.isUndefined(color)) {
                            if(color =='star') {
                                var html = '<div class="marker-star"></div>';
                            } else {
                                var html = '<div class="point-small point-'+color+'-small"></div>';
                            }
                          } else {
                            var html = '<div class="point-small point-red-small"></div>';
                          }
                          var point_popup = '<h2 class="red text-center">Coordonate:</h2>';
                        }
                    }
                    // if (position == 'end' && i == $scope.dataRoute['routes'].length - 1) {
                    //      var html = '<div class="marker-end"></div>';
                    //      var point_popup = '<h2 class="red text-center">End:</h2>';
                    // }
              } else {
                    if (!angular.isUndefined(color)) {
                      if(color =='star') {
                          var html = '<div class="marker-star"></div>';
                      } else {
                          var html = '<div class="point-small point-'+color+'-small"></div>';
                      }
                    } else {
                      var html = '<div class="point-small point-red-small"></div>';
                    }
                    var point_popup = '<h2 class="red text-center">Coordonate:</h2>';
                }
                //if(i == $scope.dataRoute['routes'].length - 1) {
                //console.log(i+'-'+$scope.no_markers+'-'+$scope.end_point)
                if($scope.end_point == 1 && i == $scope.no_markers) {
                  var html = '<div class="marker-end"></div>';
                  var point_popup = '<h2 class="red text-center">End:</h2>';
                }
                point_popup += '<div class="text-center">lat. '+latitude+'</div>';
                point_popup += '<div class="text-center">lng. '+longitude+'</div>';
                if (!angular.isUndefined(driver_date)) {
                    point_popup += '<div class="text-center">ora: ' + moment(driver_date).format('HH:mm:ss') + '</div>';
                }
                driver_point_object[i] = L.marker(
                    [latitude, longitude],
                    {
                        draggable: false,
                        icon: L.divIcon({
                            className: 'point-div-icon',
                            html: html,
                            //popupAnchor: [25, 25]
                        })
                    });
                if (!angular.isUndefined($scope.driver_points[i]) && $scope.driver_points[i] != null) {
                    $scope.driver_points[i].setLatLng([latitude, longitude]);
                } else {
                    $scope.driver_points[i] = driver_point_object[i].addTo($scope.map).bindPopup(point_popup, {
                        maxWidth: 120,
                        maxHeight: 85
                    });
                }
            }
        }

        $scope.cancel = function () {
            $scope.additionals['buttonDisabled'] = true;

            $scope.search = {};
            $scope.search['id'] = null;
            //$scope.search['driver_id'] = null;
            $scope.search['dateFrom'] = null;
            $scope.search['dateTo'] = null;
            $scope.slots_driver = [];
            $scope.slotModel = {};

            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            if(form) {
                form.reset();
            }
            $scope.routesControl = {};
            $scope.removeRouteEstimated();
            $scope.removeRouteReal();
            if ($scope.infoControl) {
                $scope.infoControl.remove($scope.map);
            }
            if ($scope.closeControl) {
                $scope.closeControl.remove($scope.map);
            }
            $scope.setCenter();

            $scope.additionals['buttonDisabled'] = false;

            $interval.cancel($rootScope.stopTimerOrderMap);
            $interval.cancel($rootScope.stopTimerSlotMap);
        }

        $scope.searchDriversPerDays = function () {
            $scope.additionals['buttonDisabled'] = true;
            var post = {};
            post['route'] = 'searchDriversPerDays';
            if (!angular.isUndefined($scope.search['dateFrom']) && $scope.search['dateFrom'] != null) {
                post['dateFrom'] = $scope.search['dateFrom'];
            } else {

                var current_init_date = new Date();
                current_init_date.setHours(0,0,0,0);
                //var current_init_date = '2024-03-18T21:30:00Z';

                var compare_date = new Date();
                compare_date.setHours(4,0,0,0);
                if(!$scope.additionals['compareDates'](new Date(), compare_date)) {
                    current_init_date.setDate(current_init_date.getDate() - 1);
                }
                post['dateFrom'] = current_init_date;
            }
            if (!angular.isUndefined($scope.search['dateTo']) && $scope.search['dateTo'] != null) {
                post['dateTo'] = $scope.search['dateTo'];
            } else {
                var current_end_date = new Date();
                current_end_date.setHours(3,59,59,0);
                //var current_end_date = '2024-03-18T22:59:00Z';

                var compare_date = new Date();
                compare_date.setHours(4,0,0,0);
                if($scope.additionals['compareDates'](new Date(), compare_date)) {
                    current_end_date.setDate(current_end_date.getDate() + 1);
                }
                post['dateTo'] = current_end_date;
            }
            if (!angular.isUndefined($scope.search['timeFrom']) && $scope.search['timeFrom'] != null) {
                post['timeFrom'] = $scope.search['timeFrom'];
            }
            if (!angular.isUndefined($scope.search['timeTo']) && $scope.search['timeTo'] != null) {
                post['timeTo'] = $scope.search['timeTo'];
            }
            $scope.additionals['drivers'] = [];
            Crud.post($scope.additionals['content_type'], post, $scope.path+'/searchDriversPerDays')
                .success(function (data) {
                    $scope.additionals['drivers'] = data;

                    /*if ($scope.state.view == 'routes' && (angular.isUndefined($scope.search['driver_id']) || $scope.search['driver_id'] == null)) {
                        if (!angular.isUndefined($scope.additionals['drivers'][0])) {
                            $scope.search['driver_id'] = $scope.additionals['drivers'][0]['id'];
                            $scope.search['id'] = null;
                        }
                    }
                    if ((!angular.isUndefined($scope.search['dateFrom']) && $scope.search['dateFrom'] != null) || (!angular.isUndefined($scope.search['dateTo']) && $scope.search['dateTo'] != null)) {
                        $scope.getSlotsDriver();
                        $scope.waypoints = [];

                        $scope.removeRouteEstimated();
                        $scope.removeRouteReal();
                        $scope.setCenter();
                    }*/

                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
        }
        $scope.searchDriversPerDays();

        $scope.getSlotsDriver = function () {
            $scope.additionals['buttonDisabled'] = true;
            var post = {};
            post['route'] = 'getSlotsDriver';
            post['dateFrom'] = $scope.search['dateFrom'];
            post['dateTo'] = $scope.search['dateTo'] ;
            post['timeFrom'] = $scope.search['timeFrom'];
            post['timeTo'] = $scope.search['timeTo'] ;
            post['driver_id'] = $scope.search['driver_id'] ;

            $scope.slots_driver = [];

            Crud.post($scope.additionals['content_type'], post, $scope.path+'/getSlotsDriver')
                .success(function (data) {

                    $scope.slots_driver = data;
                    if(data[0]) {
                        if (data[0]['id']) {
                            $scope.search['id'] = data[0]['id'];
                            $scope.getSlot(data[0]['id']);
                        } else {
                            $scope.search['id'] = null;
                            $scope.waypoints = [];

                            $scope.removeRouteEstimated();
                            $scope.removeRouteReal();
                            $scope.setCenter();
                        }
                    } else {
                        $scope.search['id'] = null;
                        $scope.waypoints = [];

                        $scope.removeRouteEstimated();
                        $scope.removeRouteReal();
                        $scope.setCenter();
                    }
                    $scope.additionals['buttonDisabled'] = false;
                });
        };

        $scope.getSlot = function (id) {
            $scope.additionals['buttonDisabled'] = true;

            var post = {};
            post['route'] = 'getSlotDriver';
            post['id'] = id;

            Crud.post($scope.additionals['content_type'], post, $scope.path+'/getSlotDriver')
                .success(function (data) {
                     if(data[0]) {
                        //$scope.driver_marker = {};
                        $scope.routesControl.route_estimated = true;
                        $scope.slotModel = data[0];

                        /* infos control */
                        if ($scope.slotModel && $scope.slotModel != null) {
                            if ($scope.infoControl) {
                                $scope.infoControl.remove($scope.map);
                            }

                            L.Control.info = L.Control.extend({
                                onAdd: function (map) {
                                     var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-info');
                                    container.title = "Detalii slot";
                                    container.onclick = function (ev) {
                                        $scope.showSlot(ev, $scope.slotModel.id);
                                    }
                                    return container;
                                }
                            });
                            L.control.info = function (opts) {
                                return new L.Control.info(opts);
                            }
                            $scope.infoControl = L.control.info({position: 'bottomright'}).addTo($scope.map);
                        }
                        /* close control */
                        if ($scope.slotModel && $scope.slotModel != null) {
                            if ($scope.closeControl) {
                                $scope.closeControl.remove($scope.map);
                            }

                            L.Control.closeSlot = L.Control.extend({
                                onAdd: function (map) {
                                    var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-close');
                                    container.title = "Inchide slot";
                                    container.onclick = function (ev) {
                                        $scope.closeSlot(ev, $scope.slotModel);
                                    }
                                    return container;
                                }
                            });
                            L.control.closeSlot = function (opts) {
                                return new L.Control.closeSlot(opts);
                            }
                            $scope.closeControl = L.control.closeSlot({position: 'bottomright'}).addTo($scope.map);
                        }
                        /* end controls */

                        if (!angular.isUndefined($scope.driver_marker)) {
                            if (!angular.isUndefined($scope.driver_marker[$scope.slotModel.driver_id]) && $scope.driver_marker[$scope.slotModel.driver_id] != null) {
                                //$scope.driver_marker[$scope.slotModel.driver_id].setLatLng([0, 0]);
                                //$scope.driver_marker[$scope.slotModel.driver_id].setOpacity(0);
                                //$scope.driver_marker[$scope.slotModel.driver_id].closeTooltip();
                            }
                        }
                        $scope.removeRouteReal();
                        $scope.removeRouteEstimated();
                        $scope.loadRouteEstimated($scope.slotModel);

                        if ($scope.slotModel.route_slot_start != null && $scope.slotModel.route_slot_end == null) {
                            $scope.getRoute($scope.slotModel.id);
                            $scope.routesControl['route_real'] = true;
                        } else {
                            $scope.routesControl['route_real'] = false;
                        }
                        if (!data[0]['orders']) {
                            $scope.setCenter();
                        }
                        angular.forEach($scope.driver_marker, function (item, key) {
                            if($scope.slotModel['driver_id'] != parseInt(key)) {
                                if (!angular.isUndefined($scope.driver_marker[key]) && $scope.driver_marker[key] != null) {
                                    //$scope.driver_marker[key].setLatLng([0, 0]);
                                    $scope.driver_marker[key].setOpacity(0);
                                    $scope.driver_marker[key].closeTooltip();
                                }
                            }
                        });
                    } else {
                        if ($scope.infoControl) {
                            $scope.infoControl.remove($scope.map);
                        }
                        if ($scope.closeControl) {
                            $scope.closeControl.remove($scope.map);
                        }
                        $scope.setCenter();

                        angular.forEach($scope.driver_marker, function (item, key) {
                            if (!angular.isUndefined($scope.driver_marker[key]) && $scope.driver_marker[key] != null) {
                                //$scope.driver_marker[key].setLatLng([0, 0]);
                                $scope.driver_marker[key].setOpacity(0);
                                $scope.driver_marker[key].closeTooltip();
                            }
                        });
                    }

                    $scope.additionals['buttonDisabled'] = false;
                });
        }

        $scope.showSlot = function (id) {
            $scope.additionals['buttonDisabled'] = true;
            Crud.show(id, $scope.path)
                .success(function (data) {
                    $scope.slotModel = data;
                    $scope.additionals['buttonDisabled'] = false;
                });
        }

        $scope.timerSlot = function () {
            var start = $scope.slotModel.route_slot_start;
            var end = $scope.slotModel.route_slot_end;

            if (start && start != null && start != 'null' && end == null) {
                var end = moment();
                var duration = moment.duration(end.diff(start));
                $scope.timersSlot = moment.utc(duration.as('milliseconds')).format('HH : mm : ss');
            }
        }

        $scope.timerOrder = function () {
            var start = $scope.modelDataOrder['order_start'];
            if( $scope.modelDataOrder['order_end'] == null ) {
                var end = moment();
                var duration = moment.duration(end.diff(start));
                $scope.timersOrder = moment.utc(duration.as('milliseconds')).format('HH : mm : ss');
            }
        }

        $scope.controlShowOrder = 0;
        $scope.additionals['dispatchTime'] = 0;
        $scope.additionals['kitchenTime'] = 0;
        $scope.additionals['plannedTime'] = 0;
        $scope.additionals['distributionTime'] = 0;
        $scope.additionals['deliveryTime'] = 0;

         $scope.additionals['calcPlannedTime'] = function (date, minDiff) {
               duration = moment(date).format("x") - minDiff*60*1000;

                 /*  var date = new Date(date);
                 var duration = new Date( date.getTime() - minDiff *1000 * 60 );
                  console.log( duration)*/

            if(duration > 0){
                return moment(duration).format('HH:mm:ss');
            } else {
                return '00:00:00';
            }
        }

        $scope.additionals['calcProcess'] = function (data) {
                 if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                        $scope.additionals['dispatchTime'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                    }
                    if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
                            $scope.additionals['kitchenTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['validated_at'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['validated_at'].substring(0, 10)+' '+data['order_planning'], data['planned_time']));
                             if (!angular.isUndefined(data['processed_at'])) {
                                $scope.additionals['plannedTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['validated_at'].substring(0, 10)+' '+data['order_planning'], data['planned_time']), data['processed_at']);
                            }
                   } else {
                        if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                $scope.additionals['kitchenTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                            }
                   }

                    if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                        $scope.additionals['distributionTime'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                    }
                    if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                        $scope.additionals['deliveryTime'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                    }
        }

        $scope.showOrder = function (ev, id) {

            $scope.additionals['buttonDisabled'] = true;
            $scope.controlShowOrder = 1;
            Crud.get($scope.path + '/showOrder?order_id='+id)
                .success(function (data) {

                    $scope.modelDataOrder = data;
                    $rootScope.stopTimerOrderMap = $interval(function () {
                        $scope.timerOrder();
                    }, 1000);

                  $scope.additionals['calcProcess'](data);

                    $scope.additionals['buttonDisabled'] = false;
                });
        };
        $scope.cancelShowOrder = function () {
            $scope.controlShowOrder = 0;
            $interval.cancel($rootScope.stopTimerOrderMap);
        }

        $scope.controlShowSlot = 0;
        $scope.showSlot = function (ev, id) {

            $scope.additionals['buttonDisabled'] = true;
            $scope.controlShowSlot = 1;
            Crud.get($scope.path + '/show/'+id)
                .success(function (data) {

                    $scope.modelDataSlot = data;

                    $scope.additionals['buttonDisabled'] = false;
                });
        };
        $scope.cancelShowSlot = function () {
            $scope.controlShowSlot = 0;
        }

        $scope.controlCloseSlot = 0;
        $scope.closeSlot = function (ev, model) {
            $scope.controlCloseSlot = 1;
        }
        $scope.closeModelSlot = function () {
            scope.additionals['invalid'] = '';
            $scope.additionals['buttonDisabled'] = true;
            $scope.isLoading = true;
            var typeRequest = 'form-urlencoded';
            var post = {};
            post['route'] = 'closeSlot';
            post['id'] = model.id;
            post['amount_driver_cash_required'] = model.amount_driver_cash_required;
            post['amount_dispatcher_cash_collected'] = model.amount_dispatcher_cash_collected;
            Crud.post(typeRequest, post, $scope.path + '/closeSlot')
                .success(function (data) {
                    $scope.isLoading = false;
                    $mdDialog.hide();
                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.errors = data.errors;
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                });
        };
        $scope.cancelCloseSlot = function () {
            $scope.controlCloseSlot = 0;
        }

        $scope.closeModelSlot = function () {
            $scope.additionals['invalid'] = '';
            $scope.additionals['buttonDisabled'] = true;
            $scope.isLoading = true;
            var typeRequest = 'form-urlencoded';
            var post = {};
            post['route'] = 'closeSlot';
            post['id'] = $scope.slotModel.id;
            post['amount_driver_cash_required'] = $scope.slotModel.amount_driver_cash_required;
            post['amount_dispatcher_cash_collected'] = $scope.slotModel.amount_dispatcher_cash_collected;
            Crud.post(typeRequest, post, $scope.path + '/closeSlot')
                .success(function (data) {
                    $scope.isLoading = false;
                    $scope.controlCloseSlot = 0;
                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.errors = data.errors;
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                });
        };

        $scope.makeMarker = function (i, slot, html, latLng) {
            var customIcon = L.divIcon({
                className: 'my-div-icon',
                html: html,
                popupAnchor: [0, -40]
            });
            var marker = L.marker(latLng, {
                draggable: false,
                icon: customIcon
            }).addTo($scope.map);

            var content = '<div><div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formMarkerOrder.html\'"></div></div>';
            var _templateScope;
            if (!_templateScope) {
                _templateScope = $scope.$new();
             }
            if (slot) {
                _templateScope.slot = slot;
            }
            _templateScope.i = i;
            var compiled = $compile(content)(_templateScope);

            var options = {
                maxWidth: 150,
                maxHeight: 70
            };
            if(slot && (slot['orders'] && slot['orders'].length > 0)) {
                var options = {
                    maxWidth: 235,
                    maxHeight: 170
                };
            }
            marker.bindPopup(compiled[0], options);

            return marker;
        }

        $scope.updateMarker = function (marker, i, slot) {

            var color_order = $scope.color_delivery;
            if(slot['orders'][i-1]['order_status'] == 4) {
                color_order = $scope.color_delivery;//curs de livrare
            }
            if(slot['orders'][i-1]['order_status'] == 5) {
                color_order = $scope.color_delivered;//livrata
            }
            if(slot['orders'][i-1]['order_status'] == 6) {
                color_order = $scope.color_undelivered;//anulata sofer
            }
            var html = '<div class="marker marker-' + color_order + '"><div>' + i  + ' </div></div> ';
            var customIcon = L.divIcon({
                className: 'my-div-icon',
                html: html,
                popupAnchor: [0, -40]
            });
            marker.setIcon(customIcon);

            var waypoints = {
                lat: slot['orders'][i-1].address_latitude,
                lng: slot['orders'][i-1].address_longitude
            };
            var popup = marker.getPopup();

            var content = '<div><div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formMarkerOrder.html\'"></div></div>';
            var _templateScope;
            if (!_templateScope) {
                _templateScope = $scope.$new();
            }
            if (slot) {
                _templateScope.slot = slot;
            }
            _templateScope.i = i;
            var compiled = $compile(content)(_templateScope);
            $scope.$apply();

            popup.setContent(compiled[0]);
        }

        $scope.updateOrderStatus = function (i, orderId, statusOrder, slotId) {

            $scope.additionals['invalid'] = '';
            var post = {};
            post['id'] = slotId;
            post['order_id'] = orderId;
            post['order_status'] = statusOrder;
            post['route'] = 'updateOrderStatus';
            var typeRequest = 'form-urlencoded';

            Crud.post(typeRequest, post, $scope.path+'/updateOrderStatus')
                .success(function (data) {
                    var color_order = $scope.color_delivery;
                    if(statusOrder == 4) {
                        color_order = $scope.color_delivery;//curs de livrare
                    }
                    if(statusOrder == 5) {
                        color_order = $scope.color_delivered;//livrata
                    }
                    if(statusOrder == 6) {
                        color_order = $scope.color_undelivered;//anulata sofer
                    }
                    var html = '<div class="marker marker-' + color_order + '"><div>' + i + ' </div></div> ';
                    var customIcon = L.divIcon({
                        className: 'my-div-icon',
                        html: html,
                        popupAnchor: [0, -40]
                    });
                    $scope.markersEstimated[i].setIcon(customIcon);
                })
                .error(function (data) {
                    $scope.errors = data.errors;
                });
        }

        $scope.addReason = function (keyOrder) {
            $scope.controlReason = [];
            $scope.controlReason[keyOrder] = 1;
        }

        $scope.closeReason = function (keyOrder) {
            $scope.additionals['buttonDisabled'] = true;

            $scope.controlReason = [];
            $scope.controlReason[keyOrder] = 0;

            setTimeout(function() {
                $scope.additionals['buttonDisabled'] = false;
            }, 500);

        }

        $scope.saveReason = function (keyOrder, idOrder, idSlot, reason) {
            $scope.additionals['buttonDisabled'] = true;
            $scope.additionals['invalid'] = '';
            var post = {};
            post['order_id'] = idOrder;
            post['slot_id'] = idSlot;
            post['reason'] = reason;
            post['route'] = 'saveReason';
            var typeRequest = 'form-urlencoded';

            Crud.post(typeRequest, post, $scope.path+'/saveReason')
                .success(function (data) {
                    $scope.additionals['buttonDisabled'] = false;
                    $scope.errors = {};
                    $scope.controlReason[keyOrder] = 1;
                    $scope.controlReason = [];

                })
                .error(function (data) {
                    $scope.errors = data.errors;
                });
            $scope.errors = {};
        }

        $scope.drivers_notifications = [];
        $scope.closeNotification = function (key, notification) {
            $scope.drivers_notifications.splice(key, 1);

            if(notification['driver_notification_type'] == 1) {
                $scope.controlDriverNotification[notification['driver_id']] = 0;
                $scope.updateColorDriverMarker(notification['driver_id'], notification['noOrdersUndeliveryByDriver']);
            }

            var post = {};
            post['id'] = notification['id'];
            post['route'] = 'closeNotification';
            Crud.post($scope.additionals['content_type'], post, $scope.path+'/closeNotification')
                .success(function (data) {
                });

        }

        /* mqtt */
        Mqtt.addListener({"id": "slot_map", "funct": mapSlot});
        function mapSlot(result, channel, self) {
            /*console.log(result)
            console.log(channel)*/

            var model =  result[0];

            if(channel == 'slot_updated') {
                if(model['action'] == 'delete_multiple') {
                    angular.forEach(result, function (item, key) {
                        if (item['noOrdersUndeliveryByDriver'] == 0) {
                            $scope.controlDriver[item['driver_id']] = 0;
                        }
                        if (item['noOrdersUndeliveryByDriver'] > 0) {
                            $scope.controlDriver[item['driver_id']] = 1;
                        }
                        $scope.updateColorDriverMarker(item['driver_id'], item['noOrdersUndeliveryByDriver']);
                    });
                } else {
                    if(model['action'] == 'change_slot') {
                        if (model['noOrdersUndeliveryByDriverCurrentSlot'] == 0) {
                            $scope.controlDriver[model['current_driver_id']] = 0;
                            $scope.updateColorDriverMarker(model['current_driver_id'], model['noOrdersUndeliveryByDriverCurrentSlot']);
                        }
                        if (model['noOrdersUndeliveryByDriverCurrentSlot'] > 0) {
                            $scope.controlDriver[model['current_driver_id']] = 1;
                            $scope.updateColorDriverMarker(model['current_driver_id'], model['noOrdersUndeliveryByDriverCurrentSlot']);
                        }

                        if (model['noOrdersUndeliveryByDriverNewSlot'] == 0) {
                            $scope.controlDriver[model['new_driver_id']] = 0;
                            $scope.updateColorDriverMarker(model['new_driver_id'], model['noOrdersUndeliveryByDriverNewSlot']);
                        }
                        if (model['noOrdersUndeliveryByDriverNewSlot'] > 0) {
                            $scope.controlDriver[model['new_driver_id']] = 1;
                            $scope.updateColorDriverMarker(model['new_driver_id'], model['noOrdersUndeliveryByDriverNewSlot']);
                        }

                    } else {

                        if (model['noOrdersUndeliveryByDriver'] == 0) {
                            $scope.controlDriver[model['driver_id']] = 0;
                        }
                        if (model['noOrdersUndeliveryByDriver'] > 0) {
                            $scope.controlDriver[model['driver_id']] = 1;
                        }
                        $scope.updateColorDriverMarker(model['driver_id'], model['noOrdersUndeliveryByDriver']);
                    }
                }
            }

            if (channel == 'driver_message_channel') {
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'messageDialog.tmpl.html',
                    parent: angular.element(document.body),
                    //targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        path: $scope.path,
                        message: model,
                        additionals: $scope.additionals
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'message', 'additionals'];
                function DialogController($scope, $mdDialog, pathTemplate, path, message, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.message = message;
                    $scope.additionals = additionals;
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.sendMessageDispatcher = function () {
                        var post = {};
                        post['route'] = 'store';
                        post['driver_id'] = $scope.message['driver_id'];
                        post['message'] = $scope.message['message_dispatcher'];

                        Crud.post($scope.additionals['content_type'], post, 'driver-message/store')
                            .success(function (data) {
                                $mdDialog.cancel();
                            });
                    };


                }
            }

            if(channel == 'order_updated') {
                if ($scope.search['id'] == result.slot_id && result['order_status'] >= 3) {
                    if (!angular.isUndefined($scope.slotModel['orders'])) {
                        var positionOrder = $scope.slotModel['orders'].map(function (e) {
                            return e['order_id'];
                        }).indexOf(parseInt(result.id));
                        if (positionOrder >= 0) {
                            $scope.slotModel['orders'][positionOrder]['order_status'] = result['order_status'];
                            $scope.slotModel['orders'][positionOrder]['reason_nondelivery'] = result['reason_nondelivery'];

                            var indiceOrder = positionOrder + 1;
                            $scope.updateMarker($scope.markersEstimated[indiceOrder], indiceOrder, $scope.slotModel);
                        }
                    }
                }
            }

            if(channel == 'order_status') {

                if (!angular.isUndefined(model['driver_notification'])) {
                    $scope.controlDriverNotification[model['driver_id']] = 1;

                    if (!angular.isUndefined(model['driver_notification_type'])) {
                        if (model['driver_notification_type'] == 1) {
                            var positionOrderType = $scope.drivers_notifications.map(function (e) {
                                return e['order_id'];
                            }).indexOf(parseInt(model.order_id));
                            if (positionOrderType < 0) {
                                $scope.drivers_notifications.push({'driver_notification': model['driver_notification'], 'driver_notification_type': model['driver_notification_type'], 'driver_id': model['driver_id'], 'driver_notification_closed': model['driver_notification_closed'], 'order_id': model['order_id'], 'noOrdersUndeliveryByDriver': model['noOrdersUndeliveryByDriver']});

                            }
                        }
                    }
                    $scope.updateColorDriverMarker(model['driver_id'], model['noOrdersUndeliveryByDriver']);
                    $scope.$apply();
                } else {
                    if(model['noOrdersUndeliveryByDriver'] == 0) {
                        $scope.controlDriver[model['driver_id']] = 0;
                    }
                    if(model['noOrdersUndeliveryByDriver'] > 0) {
                        $scope.controlDriver[model['driver_id']] = 1;
                    }
                    $scope.updateColorDriverMarker(model['driver_id'], model['noOrdersUndeliveryByDriver']);
                }

                if ($scope.search['id'] == model.slot_id && model['order_status'] >= 3) {
                    if (!angular.isUndefined($scope.slotModel['orders'])) {
                        var positionOrder = $scope.slotModel['orders'].map(function (e) {
                            return e['order_id'];
                        }).indexOf(parseInt(model.order_id));
                        if (positionOrder >= 0) {
                            $scope.slotModel['orders'][positionOrder]['order_status'] = model['order_status'];
                            $scope.slotModel['orders'][positionOrder]['reason_nondelivery'] = model['reason_nondelivery'];

                            var indiceOrder = positionOrder + 1;
                            $scope.updateMarker($scope.markersEstimated[indiceOrder], indiceOrder, $scope.slotModel);
                        }
                    }

                }
            }

            if(channel == 'slot_status') {
                if (model['action'] == 'close_slot') {
                    if ($scope.search['id'] == model.id) {
                        $scope.slotModel['slot_status'] = model['slot_status'];

                        if(model['orders']) {
                            angular.forEach(model['orders'], function (item, key) {
                                if( model['orders'][key]['order_id'] == $scope.slotModel['orders'][key]['order_id'] ) {
                                    $scope.slotModel['orders'][key]['order_status'] = model['orders'][key]['order_status'];
                                    $scope.slotModel['orders'][key]['reason_nondelivery'] = model['orders'][key]['reason_nondelivery'];

                                    var indiceOrder = parseInt(key) + 1;
                                    $scope.updateMarker($scope.markersEstimated[indiceOrder], indiceOrder, $scope.slotModel);
                                }
                            });
                        }
                    }
                }
            }

            if(channel == 'slot_updated') {
                if(model['action'] == 'delete_multiple') {
                    angular.forEach(result, function (item, key) {
                        if (result[key]['action'] == 'delete_multiple') {
                            if ($scope.slots_driver) {
                                if (!angular.isUndefined($scope.slots_driver)) {
                                    var position = $scope.slots_driver.map(function (e) {
                                        return e['id'];
                                    }).indexOf(parseInt(result[key]['id']));
                                    if (position >= 0) {
                                        $scope.slots_driver.splice(position, 1);
                                    }
                                }
                            }
                            if($scope.search['id'] == result[key]['id']) {
                                $scope.search['id'] = null;
                                $scope.removeRouteEstimated();
                                $scope.removeRouteReal();
                                $scope.setCenter();
                            }

                        }
                    });

                }
                else {
                    if(model['action'] == 'change_slot') {
                        if ($scope.slots_driver) {
                            if($scope.search['id'] == model.new_slot_id) {
                                //$scope.getSlot(model.new_slot_id);
                            }
                            if($scope.search['id'] == model.current_slot_id) {
                                //$scope.getSlot(model.current_slot_id);
                            }
                        }
                    } else {
                        if (model['action'] == 'store') {
                            if($scope.additionals['drivers'].length <= 0) {
                                $scope.additionals['drivers'][0] = {
                                    'driver_name': model['driver_name'],
                                    'driver_phone': model['driver_phone'],
                                    'id': model['driver_id'],
                                };
                                $scope.search['driver_id'] = model['driver_id'];
                                $scope.$apply();
                            } else {
                                if (!angular.isUndefined($scope.additionals['drivers'])) {
                                    var positionDriver = $scope.additionals['drivers'].map(function (e) {
                                        return e['id'];
                                    }).indexOf(parseInt(model['driver_id']));
                                    if (positionDriver < 0) {
                                        $scope.additionals['drivers'].push({
                                            'driver_name': model['driver_name'],
                                            'driver_phone': model['driver_phone'],
                                            'id': model['driver_id'],
                                        });
                                    }
                                }
                            }
                            if($scope.state.view == 'routes') {
                                if ($scope.additionals['compareDates'](model['created_at'], $scope.additionals['combineDateTime']($scope.search['dateFrom'], $scope.search['timeFrom'])) && $scope.additionals['compareDates']($scope.additionals['combineDateTime']($scope.search['dateTo'], $scope.search['timeTo']), model['created_at'])) {

                                    if($scope.search['driver_id'] == model['driver_id']) {
                                        $scope.slots_driver.push(model);
                                        if ($scope.search['id'] == null) {
                                            $scope.search['id'] = model.id;
                                            $scope.removeRouteEstimated();
                                            $scope.loadRouteEstimated(model);
                                            $scope.$apply();
                                        }
                                    }

                                }
                            }
                        }
                        if (model['action'] == 'update' || model['action'] == 'delete') {

                            if (!angular.isUndefined($scope.additionals['drivers'])) {
                                var positionDriver = $scope.additionals['drivers'].map(function (e) {
                                    return e['id'];
                                }).indexOf(parseInt($scope.search['driver_id']));
                                if (positionDriver >= 0) {
                                    if ($scope.additionals['drivers'][positionDriver]['driver_phone'] == model['driver_phone']) {

                                        if (model['action'] == 'update') {
                                            if ($scope.additionals['compareDates'](model['created_at'], $scope.additionals['combineDateTime']($scope.search['dateFrom'], $scope.search['timeFrom'])) && $scope.additionals['compareDates']($scope.additionals['combineDateTime']($scope.search['dateTo'], $scope.search['timeTo']), model['created_at'])) {
                                                if ($scope.search['id'] == null) {
                                                    if ($scope.slots_driver) {
                                                        $scope.slots_driver.push(model);
                                                    }
                                                    $scope.search['id'] = model.id;
                                                }
                                                if ($scope.search['id'] == model.id || $scope.search['id'] == null) {
                                                    $scope.removeRouteEstimated();
                                                    $scope.loadRouteEstimated(model);
                                                }
                                                if ($scope.search['id'] != model.id) {
                                                    if ($scope.slots_driver) {
                                                        $scope.slots_driver.push(model);
                                                    }
                                                }
                                                $scope.$apply();
                                            }
                                        }

                                        if (model['action'] == 'delete') {
                                            if (!angular.isUndefined($scope.slots_driver)) {
                                                if ($scope.slots_driver) {
                                                    var position = $scope.slots_driver.map(function (e) {
                                                        return e['id'];
                                                    }).indexOf(parseInt(model.id));
                                                    if (position >= 0) {
                                                        $scope.slots_driver.splice(position, 1);
                                                        if ($scope.search['id'] == model.id) {
                                                            $scope.search['id'] = null;

                                                            $scope.removeRouteEstimated();
                                                            $scope.removeRouteReal();
                                                            $scope.setCenter();
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                    } else {
                                        if (model['action'] == 'update') {
                                            if (!angular.isUndefined($scope.slots_driver)) {
                                                if ($scope.slots_driver) {
                                                    var position = $scope.slots_driver.map(function (e) {
                                                        return e['id'];
                                                    }).indexOf(parseInt(model.id));
                                                    if (position >= 0) {
                                                        $scope.slots_driver.splice(position, 1);
                                                        if ($scope.search['id'] == model.id) {
                                                            $scope.search['id'] = null;

                                                            $scope.removeRouteEstimated();
                                                            $scope.removeRouteReal();
                                                            $scope.setCenter();
                                                        }
                                                    }
                                                }
                                            }

                                        }
                                    }
                                }
                            }
                        }


                    }

                }

            }

            if(channel == 'driver_route_channel') {

                if ($scope.state.view == 'routes') {

                    if ($scope.search['id'] == result[0].slot_id) {
                        if (!angular.isUndefined(result)) {
                            if (!angular.isUndefined($scope.slotModel) && $scope.slotModel != null) {
                                    if(result[0].route_slot_start != null && result[0].route_slot_end == null) {
                                        $scope.controlDriver[result[0]['driver_id']] = 1;
                                    } else {
                                        $scope.controlDriver[result[0]['driver_id']] = 0;
                                    }
                                    $scope.addDriverMarker(result[0]['driver'], result[0]['driver_latitude'], result[0]['driver_longitude'], result[0]['noOrdersUndeliveryByDriver']);
                                    $scope.executed = false;

                                    if (!angular.isUndefined(result[0]['route_slot_start']) && result[0]['route_slot_start'] != null) {
                                        $scope.slotModel.route_slot_start = result[0]['route_slot_start'];
                                    }
                                    $scope.slotModel.route_slot_end = result[0]['route_slot_end'];
                                    $scope.routesControl.route_real = true;

                                    var model = {};
                                    model.id = result[0].slot_id;
                                    model.routes = result;
                                    $scope.loadRouteReal(model, null);

                                    if($scope.slotModel) {
                                        if (!angular.isUndefined(result[0]['route_slot_end']) && result[0]['route_slot_end'] != null) {
                                            if (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap != null) {
                                                $interval.cancel($rootScope.stopTimerSlotMap);
                                            }
                                        } else {
                                            if (angular.isUndefined($rootScope.stopTimerSlotMap) || $rootScope.stopTimerSlotMap == null || (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap.$$state.value == 'canceled')) {
                                                $rootScope.stopTimerSlotMap = $interval(function () {
                                                    $scope.timerSlot();
                                                }, 1000);
                                            }
                                            $scope.$apply();
                                        }
                                    }

                                }
                        }
                    }
                } else {
                    if (!angular.isUndefined(result)) {
                        if (!angular.isUndefined(result[1])) {
                            /*if(result[1].route_slot_start != null && result[1].route_slot_end == null) {
                                $scope.controlDriver[result[1]['driver_id']] = 1;
                            } else {
                                $scope.controlDriver[result[1]['driver_id']] = 0;
                                //$scope.map.removeLayer($scope.driver_marker[result[1]['driver_id']]);
                            }*/
                            if(result[1]['noOrdersUndeliveryByDriver'] == 0) {
                                $scope.controlDriver[result[1]['driver_id']] = 0;
                            }
                            if(result[1]['noOrdersUndeliveryByDriver'] > 0) {
                                $scope.controlDriver[result[1]['driver_id']] = 1;
                            }
                            $scope.addDriverMarker(result[1]['driver'], result[1]['driver_latitude'], result[1]['driver_longitude'],  result[1]['noOrdersUndeliveryByDriver']);
                            $scope.executed = false;

                        } else {

                            /*if(result[0].route_slot_start != null && result[0].route_slot_end == null) {
                                $scope.controlDriver[result[0]['driver_id']] = 1;
                            } else {
                                $scope.controlDriver[result[0]['driver_id']] = 0;
                            }*/
                            if(result[0]['noOrdersUndeliveryByDriver'] == 0) {
                                $scope.controlDriver[result[0]['driver_id']] = 0;
                            }
                            if(result[0]['noOrdersUndeliveryByDriver'] > 0) {
                                $scope.controlDriver[result[0]['driver_id']] = 1;
                            }
                            $scope.addDriverMarker(result[0]['driver'], result[0]['driver_latitude'], result[0]['driver_longitude'],  result[0]['noOrdersUndeliveryByDriver']);
                            $scope.executed = false;


                        }
                    }
                }
            }

            //console.log(channel)
            //console.log(result)
            if(channel == 'driver_logout_channel') {
                $scope.removeDriver(result[0]['id']);
                $scope.$apply();
            }

            if(channel == 'driver_position_channel') {
                if ($scope.state.view == 'routes') {

                    if ($scope.search['id'] == result[0].slot_id) {
                        if (!angular.isUndefined(result)) {
                            if (!angular.isUndefined(result[1])) {
                                if (!angular.isUndefined($scope.slotModel) && $scope.slotModel != null) {
                                    if(result[1].route_slot_start != null && result[1].route_slot_end == null) {
                                        $scope.controlDriver[result[1]['driver_id']] = 1;
                                    } else {
                                        $scope.controlDriver[result[1]['driver_id']] = 0;
                                    }
                                    $scope.addDriverMarker(result[1]['driver'], result[1]['driver_latitude'], result[1]['driver_longitude'], result[1]['noOrdersUndeliveryByDriver']);
                                    $scope.executed = false;

                                    if (!angular.isUndefined(result[0]['route_slot_start']) && result[0]['route_slot_start'] != null) {
                                        $scope.slotModel.route_slot_start = result[0]['route_slot_start'];
                                    }
                                    $scope.slotModel.route_slot_end = result[1]['route_slot_end'];
                                    $scope.routesControl.route_real = true;

                                    var model = {};
                                    model.id = result[0].slot_id;
                                    model.routes = result;
                                    $scope.loadRouteReal(model, null);

                                    if($scope.slotModel) {
                                        if (!angular.isUndefined(result[1]['route_slot_end']) && result[1]['route_slot_end'] != null) {
                                            if (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap != null) {
                                                $interval.cancel($rootScope.stopTimerSlotMap);
                                            }
                                        } else {
                                            if (angular.isUndefined($rootScope.stopTimerSlotMap) || $rootScope.stopTimerSlotMap == null || (!angular.isUndefined($rootScope.stopTimerSlotMap) && $rootScope.stopTimerSlotMap.$$state.value == 'canceled')) {
                                                $rootScope.stopTimerSlotMap = $interval(function () {
                                                    $scope.timerSlot();
                                                }, 1000);
                                            }
                                            $scope.$apply();
                                        }
                                    }

                                }
                            } else {
                                if(result[0].route_slot_start != null && result[0].route_slot_end == null) {
                                    $scope.controlDriver[result[0]['driver_id']] = 1;
                                } else {
                                    $scope.controlDriver[result[0]['driver_id']] = 0;
                                }
                                $scope.addDriverMarker(result[0]['driver'], result[0]['driver_latitude'], result[0]['driver_longitude'],  result[0]['noOrdersUndeliveryByDriver']);
                                $scope.executed = false;
                            }
                        }
                    }

                } else {
                    if (!angular.isUndefined(result)) {
                        if (!angular.isUndefined(result[1])) {
                            /*if(result[1].route_slot_start != null && result[1].route_slot_end == null) {
                                $scope.controlDriver[result[1]['driver_id']] = 1;
                            } else {
                                $scope.controlDriver[result[1]['driver_id']] = 0;
                                //$scope.map.removeLayer($scope.driver_marker[result[1]['driver_id']]);
                            }*/
                            if(result[1]['noOrdersUndeliveryByDriver'] == 0) {
                                $scope.controlDriver[result[1]['driver_id']] = 0;
                            }
                            if(result[1]['noOrdersUndeliveryByDriver'] > 0) {
                                $scope.controlDriver[result[1]['driver_id']] = 1;
                            }
                            $scope.addDriverMarker(result[1]['driver'], result[1]['driver_latitude'], result[1]['driver_longitude'],  result[1]['noOrdersUndeliveryByDriver']);
                            $scope.executed = false;

                        } else {

                            /*if(result[0].route_slot_start != null && result[0].route_slot_end == null) {
                                $scope.controlDriver[result[0]['driver_id']] = 1;
                            } else {
                                $scope.controlDriver[result[0]['driver_id']] = 0;
                            }*/
                            if(result[0]['noOrdersUndeliveryByDriver'] == 0) {
                                $scope.controlDriver[result[0]['driver_id']] = 0;
                            }
                            if(result[0]['noOrdersUndeliveryByDriver'] > 0) {
                                $scope.controlDriver[result[0]['driver_id']] = 1;
                            }
                            $scope.addDriverMarker(result[0]['driver'], result[0]['driver_latitude'], result[0]['driver_longitude'], result[0]['noOrdersUndeliveryByDriver']);
                            $scope.executed = false;


                        }
                    }
                }
            }

            if(channel == 'driver_return_channel') {
                if(result[0]['driver_return'] == '1') {
                    if (!angular.isUndefined($scope.additionals['drivers_return'])) {
                        var positionDriver = $scope.additionals['drivers_return'].map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(result[0]['id']));
                        if (positionDriver >= 0) {
                            $scope.additionals['drivers_return'][positionDriver] = result[0];
                        } else {
                            $scope.additionals['drivers_return'].unshift(result[0]);
                        }
                        $scope.controlDriversReturn = 1;
                    }
                } else {
                    if (!angular.isUndefined($scope.additionals['drivers_return'])) {
                        var positionDriver = $scope.additionals['drivers_return'].map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(result[0]['id']));
                        if (positionDriver >= 0) {
                            $scope.additionals['drivers_return'].splice(positionDriver, 1);
                        }
                    }
                }
                $scope.$apply();
            }
        }
        /* end mqtt */

        /* map */
        $scope.center = [46.779608, 23.593165];
        $scope.center_address = 'Cluj-Napoca, Strada Daniil P. Barceanu 10';

        /*var oCal= L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; 2013 OpenStreetMap contributors',
        });

        var map = L.map('map-route')
            .fitWorld()
            .addLayer(osm);

        var wind = L.polyline([[59.3556, -31.99219],[55.17887, -42.89062],[47.7541, -43.94531],[38.27269, -37.96875],[27.05913, -41.13281],[16.29905, -36.5625],[8.40717, -30.23437],[1.05463, -22.5],[-8.75479, -18.28125],[-21.61658, -20.03906],[-31.35364, -24.25781],[-39.90974, -30.9375],[-43.83453, -41.13281],[-47.7541, -49.92187],[-50.95843, -54.14062],[-55.9738, -56.60156]], {
            weight: 15,
            color: '#8EE9FF'
        }).addTo(map);
        wind.setText(') ', {repeat: true,
            offset: 7,
            attributes: {fill: '#007DEF',
                'font-weight': 'bold',
                'font-size': '24'}});*/

        $rootScope.$on('$routeChangeSuccess', function (event) {
            //$scope.map.off();
            //$scope.map.remove();
            //document.getElementById('map-route').innerHTML = '';
        });

        $scope.initMap = function () {
            var LocalOpenStreet = L.tileLayer(
                'https://api.947.ro:8081/tiles/{z}/{x}/{y}.png',
                {maxZoom: 22, type: 'osm_local'}
            );

            if (!$scope.map || $scope.map == undefined) {
                $scope.map = L.map('map-route', {
                    center: $scope.center,
                    zoom: 13,
                    //scrollWheelZoom: true,
                    zoomControl: true,
                    layers: [LocalOpenStreet],
                });
                /*$scope.map.flyTo($scope.center, 14, {
                    animate: true,
                    duration: 3
                });*/
                //$scope.markersEstimated[0] = $scope.makeMarker(0, 0, '<div class="marker marker-center"></div>', {lat:$scope.center[0], lng:$scope.center[1]});

                $scope.map.doubleClickZoom.disable();
                $scope.map.zoomControl.setPosition('bottomright');
                //$scope.map.invalidateSize();
                $scope.map._onResize();

                var brightnessMapControl =  L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-brightnessmap');
                        container.title = "Luminozitate/contrast";
                        container.onclick = function(ev) {
                            $scope.brightnessMap(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new brightnessMapControl());

                if ($route.current.$$route.originalPath != '/slot/mapFullscreen') {
                    var fullMapControl = L.Control.extend({
                        options: {
                            position: 'bottomright'
                        },
                        onAdd: function (map) {
                            var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullmap minus');
                            container.title = "Extinde harta";
                            container.onclick = function (ev) {
                                $scope.fullsizeMap(ev);
                            }
                            return container;
                        }
                    });
                    $scope.map.addControl(new fullMapControl());

                    var fullScreenControl = L.Control.extend({
                        options: {
                            position: 'bottomright'
                        },
                        onAdd: function (map) {
                            var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullscreen minus');
                            container.title = "Fullscreen";
                            container.onclick = function (ev) {
                                $scope.fullscreenMap(ev);
                            }
                            return container;
                        }
                    });
                    $scope.map.addControl(new fullScreenControl());
                } else {
                    $('.open-layers').css('right','10px');
                }

                var legend = L.control({position: 'bottomleft'});
                legend.onAdd = function (map) {
                    var div = L.DomUtil.create('div', 'info legend'),
                        colors = ['rgba(255, 252, 0, 1)', '#78bf44', '#1f1f1f', '#e7534e', '#'+$scope.color, '#'+$scope.color_driver, '#'+$scope.color_delivery, '#'+$scope.color_delivered, '#'+$scope.color_undelivered],
                        labels = ['Sediu', 'Sofer liber', 'Sofer activ', 'Sofer alertat', 'Itinerariu estimat', 'Itinerariu efectuat', 'Comanda curs de livrare', 'Comanda livrata', 'Comanda anulata sofer'];
                    var closeButton = '<button type="button" id="close-legend">Legend</button>';
                    var html = closeButton+'<div class="div-legend hide">';
                    for (var i = 0; i < colors.length; i++) {
                       html +=
                            '<i style="background:' + colors[i] + '"></i> ' +
                            labels[i] + '<br>' ;
                    }
                    html += '</div>';
                    div.innerHTML = html;
                    div.onclick = function (ev) {
                        $scope.toggleLegend();
                    }
                    return div;
                };
                legend.addTo($scope.map);

                var OpenStreetMap = L.tileLayer(
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    {maxZoom: 18, type: 'osm'}
                );
                var terrainMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'terrain'
                });
                var hybridMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'hybrid'
                });
                var roadMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                var satMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'satellite'
                });
                var trafficMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                var transitMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                L.control.layers({
                    'LocalOpenStreet': LocalOpenStreet,
                    'OpenStreetMap': OpenStreetMap,
                    'Google Terrain': terrainMutant,
                    'Google Hybrid': hybridMutant,
                    'Google Roadmap': roadMutant,
                    'Google Aerial': satMutant,
                    'Google Traffic': trafficMutant,
                    'Google Transit': transitMutant
                }, {}, {
                    collapsed: false  /*set true if wants event on mouseover*/
                }).addTo($scope.map);

                $('.leaflet-control-layers').hide();
                $('.leaflet-control-layers').css('top','15px');
                $('.leaflet-control-layers').css('right','15px');

                $scope.map.on('baselayerchange', function(e) {
                    $scope.map.eachLayer(function(layer) {
                        if (layer.options.type == 'terrain' || layer.options.type == 'hybrid' || layer.options.type == 'road' || layer.options.type == 'sat' || layer.options.type == 'traffic' || layer.options.type == 'transit') {
                            $scope.map.options.maxZoom = 20;
                        }
                        if (layer.options.type == 'osm_local' || layer.options.type == 'osm') {
                            $scope.map.options.maxZoom = 22;
                        }
                    });
                });
            }
        }

        $scope.openLayers = function () {
            $('.leaflet-control-layers').toggle();
        }

        setTimeout(function() {
            $scope.initMap();
            if ($route.current.$$route.originalPath == '/slot/mapFullscreen') {
                $scope.fullscreenMap();
            } else {
                $scope.controlFullscreenMap = 1;
                $scope.fullscreenMap();
            }
        }, 500);

        $scope.brightnessMap = function (ev) {
            angular.element(document.querySelector('.leaflet-layer')).toggleClass('opacity-layer ');
            angular.element(document.querySelector('.leaflet-google-layer')).toggleClass('opacity-layer ');
        }

        $scope.fullsizeMap = function (ev) {
            $scope.fullSize();
            angular.element(document.querySelector('.leaflet-control-fullmap')).toggleClass('minus plus');
            if ($scope.map) {
                $scope.map.invalidateSize();
                $scope.map._onResize();
            }
        }

        $scope.controlFullscreenMap = 0;
        $scope.fullscreenMap = function (ev) {
            //$scope.goPreview('map-canvas');
            if($scope.controlFullscreenMap == 1) {
                $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .loader, .cute').removeClass('hide');
                $('body').removeClass('full-screen');
                $scope.controlFullscreenMap = 0;
                angular.element(document.querySelector('.expand-drivers-return')).css('left', '30px');
            } else {
                $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .loader, .cute').addClass('hide');
                $('body').addClass('full-screen');
                $scope.controlFullscreenMap = 1;
                angular.element(document.querySelector('.expand-drivers-return')).css('left', '4px');
            }
            angular.element(document.querySelector('.leaflet-control-fullscreen')).toggleClass('minus plus');
            angular.element(document.querySelector('.angular-leaflet-map')).css('height', '100%');

            if ($scope.map) {
                $scope.map.invalidateSize();
                $scope.map._onResize();
            }
        }

        $scope.toggleLegend = function () {
            angular.element(document.querySelector('.div-legend')).toggleClass('hide show');
        }

        $scope.controlSearchForm = 0;
        $scope.expandSearchForm = function () {
            if($scope.controlSearchForm == 1) {
                $scope.controlSearchForm = 0;
                angular.element(document.querySelector('.expand-drivers-return')).css('top', '12%');
                angular.element(document.querySelector('.full-screen .expand-drivers-return')).css('top', '7%');
                angular.element(document.querySelector('#map-canvas')).css('height', 'calc(155vh - 0px)');
            } else {
                $scope.controlSearchForm = 1;
                if ($scope.state.view == 'routes') {
                  setTimeout( function() {
                    var heightFormSearch = $('#search-form').height() - 50;
                    if ($route.current.$$route.originalPath != '/slot/mapFullscreen') {
                        angular.element(document.querySelector('.expand-drivers-return')).css('top', document.querySelector('.expand-drivers-return').getBoundingClientRect().top + heightFormSearch - 60 +'px');
                    } else {
                        angular.element(document.querySelector('.expand-drivers-return')).css('top', document.querySelector('.expand-drivers-return').getBoundingClientRect().top + heightFormSearch +'px');
                    }
                    angular.element(document.querySelector('#map-canvas')).css('height', $('#map-canvas').height() + heightFormSearch +'px');
                    $scope.map.invalidateSize();
                    $scope.map._onResize();
                  }, 100);
                }
            }
        }

        $scope.controlDriversReturn = 1;
        $scope.expandDriversReturn = function () {
            if($scope.controlDriversReturn == 1) {
                $scope.controlDriversReturn = 0;
            } else {
                $scope.controlDriversReturn = 1;
            }
        }
        $scope.additionals['drivers_return'] = [];
        $scope.getDriversReturn = function () {
            Crud.get($scope.path + '/getDriversReturn')
                .success(function (data) {
                    $scope.additionals['drivers_return'] = data;
                });
        }
        //$scope.getDriversReturn();

        $scope.controlDriversList = 1;
        $scope.expandDriversList = function () {
            if($scope.controlDriversList == 1) {
                $scope.controlDriversList = 0;
            } else {
                $scope.controlDriversList = 1;
            }
        }
        $scope.additionals['drivers_list'] = [];
        $scope.getDriversList = function () {
            Crud.get($scope.path + '/getDriversList')
                .success(function (data) {
                    $scope.additionals['drivers_f'] = data['drivers_f'];
                    $scope.additionals['drivers_b'] = data['drivers_b'];
                });
        }
        $scope.getDriversList();

        $scope.setCenter = function () {
            var center_popup = '<h2 class="text-center">'+$scope.center_address+'</h2>';
            // if ($scope.map) {
            //     L.marker(
            //         $scope.center,
            //         {
            //             draggable: false,
            //             icon: L.divIcon({
            //                 className: 'driver-div-icon',
            //                 html: '<div class="marker marker-center"></div>',
            //                 popupAnchor: [0, -40]
            //             })
            //         }).addTo($scope.map).bindPopup(center_popup, {maxWidth: 150, maxHeight: 70});
            // }
        }

        $scope.routingControl = {};
        $scope.routesControl = {};
        $scope.routesControl.route_estimated = true;

        $scope.loadRouteEstimated = function(slot) {
            if (!angular.isUndefined($scope.center_marker)) {
                $scope.map.removeLayer($scope.center_marker);
            }
            $scope.waypoints = [];
            var html = '';

            if($scope.map) {
                if (slot && slot != null) {
                    if (typeof slot['orders'] != 'undefined') {
                        $scope.orders = slot['orders'];
                    }
                    if (typeof slot['orders'] != 'undefined') {

                        if (slot['orders'] && slot['orders'].length > 0) {
                            $scope.markersEstimated[0] = $scope.makeMarker(0, slot, '<div class="marker marker-center"></div>', {
                                lat: $scope.center[0],
                                lng: $scope.center[1]
                            });

                            angular.forEach(slot.orders, function (itemOrder, keyOrder) {
                                var keyOrders = parseInt(keyOrder) + 1;
                                $scope.waypoints[keyOrders] = {
                                    lat: slot.orders[keyOrder].address_latitude,
                                    lng: slot.orders[keyOrder].address_longitude
                                };
                                if (!angular.isUndefined(slot['orders'][keyOrders - 1])) {
                                    if (slot['orders'][keyOrders - 1]['order_status'] == 4) {
                                        html = '<div class="marker marker-' + $scope.color_delivery + '"><div>' + keyOrders + ' </div></div> ';
                                    }
                                    if (slot['orders'][keyOrders - 1]['order_status'] == 5) {
                                        html = '<div class="marker marker-' + $scope.color_delivered + '"><div>' + keyOrders + ' </div></div> ';
                                    }
                                    if (slot['orders'][keyOrders - 1]['order_status'] == 6) {
                                        html = '<div class="marker marker-' + $scope.color_undelivered + '"><div>' + keyOrders + ' </div></div> ';
                                    }
                                }
                                $scope.markersEstimated[keyOrders] = $scope.makeMarker(keyOrders, slot, html, $scope.waypoints[keyOrders]);
                            });
                        }

                        /*if (!angular.isUndefined(slot.osrm)) {
                            var route = L.PolylineUtil.decode(slot.osrm[0].geometry, 6);

                            if((!slot['route_slot_start'] || slot['route_slot_start'] != null) && (!slot['route_slot_end'] || slot['route_slot_end'] == null)) {
                                if (($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 0) || ($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 1))  {
                                    $scope.routeEstimated = L.polyline(route, {
                                        color: '#' + $scope.color,
                                        opacity: 1,
                                        weight: 5
                                    });
                                    //→  ► >
                                    $scope.routeEstimated.setText('   →   ', {
                                        repeat: true,
                                        attributes: {
                                            fill: '404040',
                                            'font-weight': 'bold',
                                            'font-size': '18'
                                        }
                                    });
                                    if($scope.routeEstimated) {
                                        $scope.routeEstimated.addTo($scope.map).snakeIn();
                                    }
                                }
                                if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 1) {
                                    var {antPath} = L.polyline;
                                    $scope.routeEstimated = antPath(route, {
                                        color: '#' + $scope.color,
                                        opacity: 1,
                                        weight: 5
                                    });
                                    //→  ► >
                                    $scope.routeEstimated.setText('   →   ', {
                                        repeat: true,
                                        attributes: {
                                            fill: '404040',
                                            'font-weight': 'bold',
                                            'font-size': '18'
                                        }
                                    });
                                    $scope.routeEstimated.addTo($scope.map);
                                    $scope.map.fitBounds($scope.routeEstimated.getBounds());
                                }

                                if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 0) {
                                    $scope.routeEstimated = L.polyline(route, {color: '#' + $scope.color, opacity: 1, weight: 5});
                                    //→  ► >
                                    $scope.routeEstimated.setText('   →   ', {
                                        repeat: true,
                                        attributes: {
                                            fill: '404040',
                                            'font-weight': 'bold',
                                            'font-size': '18'
                                        }
                                    });
                                    $scope.routeEstimated.addTo($scope.map);
                                    $scope.map.fitBounds($scope.routeEstimated.getBounds());
                                }
                            } else {
                                $scope.routeEstimated = L.polyline(route, {color: '#' + $scope.color, opacity: 1, weight: 5});
                                //→  ► >
                                $scope.routeEstimated.setText('   →   ', {
                                    repeat: true,
                                    attributes: {
                                        fill: '404040',
                                        'font-weight': 'bold',
                                        'font-size': '18'
                                    }
                                });
                                $scope.routeEstimated.addTo($scope.map);
                                $scope.map.fitBounds($scope.routeEstimated.getBounds());
                            }

                        }*/

                    }
                }
            }
        }

        $scope.removeRouteEstimated = function() {
            if (!angular.isUndefined($scope.routeEstimated)) {
                $scope.routeEstimated.remove($scope.map);
            }
            if ($scope.markersEstimated.length > 0) {
                angular.forEach($scope.markersEstimated, function (itemMarker, keyMarker) {
                    if (!angular.isUndefined($scope.markersEstimated[keyMarker])) {
                        $scope.map.removeLayer($scope.markersEstimated[keyMarker]);
                    }
                });
            }
        }

        $scope.loadRouteRealy = function(slot, mode, off) {
            if (!angular.isUndefined($scope.center_marker)) {
                $scope.map.removeLayer($scope.center_marker);
            }
            $scope.waypoints = [];
            $scope.lay = [];
            if (!angular.isUndefined(slot['routes'])) {
                if (slot['routes'] && slot['routes'].length > 0) {
                    if(off > 1) {
                        $scope.no_markers = $scope.no_markers + 1 + 1;
                    }
                    let latlngs = []; let driver_point_object = []; let colorRoute = $scope.color_driver;
                    var opacity = 0.7;
                    if(mode && mode == 'all') {
                        angular.forEach(slot['routes'], function (itemRoute, keyRoute) {
                            latlngs[keyRoute] = [slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude']];

                            var diffOrder = 0; var diffOrderNext = 0;
                            if (!angular.isUndefined(slot['routes'][keyRoute+1])) {
                                latlngs[keyRoute+1] = [slot['routes'][keyRoute+1]['driver_latitude'], slot['routes'][keyRoute+1]['driver_longitude']];

                                var diffOrder = $scope.additionals['diffDatesMinutes'](itemRoute['driver_date'], slot['routes'][keyRoute+1]['driver_date']);

                                if (!angular.isUndefined(slot['routes'][keyRoute+2])) {
                                  var diffOrderNext = $scope.additionals['diffDatesMinutes'](slot['routes'][keyRoute+1]['driver_date'], slot['routes'][keyRoute+2]['driver_date']);
                                }
                            }

                            if(keyRoute == 0) {
                              $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date'], 'start');
                            }
                            if(keyRoute == slot['routes'].length - 1) {
                              // $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date'], 'end');
                            }

                            if(itemRoute['noOrdersUndeliveryByDriver'] > 0) {
                              //red busy driver
                              colorRoute = $scope.color_driver;
                              opacity = 0.71;
                              //if(keyRoute != 0 && keyRoute != slot['routes'].length - 1) {
                                $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date']);
                              //}
                            } else {
                              //green free driver
                              colorRoute = '418c43';
                              opacity = 0.72;
                              //if(keyRoute != 0 && keyRoute != slot['routes'].length - 1) {
                                $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date'], null, 'green');
                              //}
                            }
                            if(diffOrder > 10) {
                                //gray driver deconected
                                colorRoute = '717171';
                                opacity = 0.5;
                                if(!angular.isUndefined(diffOrderNext) && diffOrderNext > 0 && diffOrderNext <= 10) {
                                    if(!angular.isUndefined(slot['routes'][keyRoute+1])) {
                                      $scope.addDriverPoint(slot['routes'][keyRoute+1]['driver_latitude'], slot['routes'][keyRoute+1]['driver_longitude'], slot['routes'][keyRoute+1]['driver_date'], null, 'star');
                                    }
                                }
                            } else {
                                if(!angular.isUndefined(diffOrderNext) && diffOrderNext > 10) {
                                  if(!angular.isUndefined(slot['routes'][keyRoute+1])) {
                                    $scope.addDriverPoint(slot['routes'][keyRoute+1]['driver_latitude'], slot['routes'][keyRoute+1]['driver_longitude'], slot['routes'][keyRoute+1]['driver_date'], null, 'star');
                                  }
                                }
                            }

                            if (!angular.isUndefined(slot['routes'][keyRoute+1])) {
                                if (angular.isUndefined($scope.routeReal[off])) {
                                    $scope.routeReal[off] = [];
                                }
                                if (angular.isUndefined($scope.routeReal[off][keyRoute])) {
                                    $scope.routeReal[off][keyRoute] = [];
                                }
                                if (!angular.isUndefined(latlngs[keyRoute]) && !angular.isUndefined(latlngs[keyRoute+1])) {
                                  $scope.routeReal[off][keyRoute] =  L.polyline([latlngs[keyRoute], latlngs[keyRoute+1]], {color: '#'+colorRoute, weight: 5, opacity: opacity, snakingSpeed: 200});
                                }
                                if (($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 0) || ($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 1)) {
                                    //→  ► >
                                    $scope.routeReal[off][keyRoute].setText('   →   ', {
                                        repeat: true,
                                        attributes: {
                                            fill: '404040',
                                            'font-weight': 'bold',
                                            'font-size': '18'
                                        }
                                    });
                                    $scope.lay.push($scope.routeReal[off][keyRoute]);
                                }

                                if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 1) {
                                    //→  ► >
                                    $scope.routeReal[off][keyRoute].setText('   →   ', {
                                        repeat: true,
                                        attributes: {
                                            fill: '404040',
                                            'font-weight': 'bold',
                                            'font-size': '18'
                                        }
                                    });
                                    $scope.routeReal[off][keyRoute].addTo($scope.map);
                                }

                                if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 0) {
                                    $scope.routeReal[off][keyRoute].addTo($scope.map);
                                }
                            }
                        });
                        //latlngs= [["46.7712", "23.6236"], ["46.7312", "23.6136"]];//for snake effect
                        //console.log(latlngs)
                        //$scope.routeReal[off] = L.polyline(latlngs, {color: '#' + $scope.color_driver, weight: 5, opacity: 0.7, snakingSpeed: 200});

                        if (($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 0) || ($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 1))  {
                            //→  ► >
                            // $scope.routeReal[off][keyRoute].setText('   →   ', {
                            //     repeat: true,
                            //     attributes: {
                            //         fill: '404040',
                            //         'font-weight': 'bold',
                            //         'font-size': '18'
                            //     }
                            // });
                            /*
                            $scope.routeReal[off].addTo($scope.map).snakeIn();
                            $scope.routeReal[off].on('snakestart snake snakeend', function(ev){
                                if(ev.type == 'snakeend') {
                                    $scope.getRouteByDriver();
                                }
                            });*/
                            // if (angular.isUndefined($scope.lay)) {
                            //     $scope.lay = [];
                            // }
                            // $scope.lay = [
                            //     //$scope.driver_points[0],
                            //     $scope.routeReal[off],
                            //     //$scope.driver_points[1]
                            // ];
                            /*$scope.lay = $scope.lay.concat([driver_point_object[slot['routes'].length-1]]);
                            for (i = 1; i < slot['routes'].length; i++) {
                                $scope.lay = $scope.lay.concat([driver_point_object[i]]);
                            }*/
                            var route = L.layerGroup(
                                $scope.lay
                                , { snakingPause: 200 });
                            route.addTo($scope.map).snakeIn();
                            route.on('snakestart snake snakeend', function(ev){
                                if(ev.type == 'snakeend') {
                                    /*console.log('len'+slot['routes'].length)
                                    console.log('lim'+$scope.limit)
                                    console.log('offset'+$scope.offset)*/
                                    if($scope.offset == $scope.limit) {
                                        if (slot['routes'].length == $scope.limit) {
                                            $scope.getRouteByDriver();
                                        }
                                    } else {
                                        if (slot['routes'].length - 1 == $scope.limit) {
                                            $scope.getRouteByDriver();
                                        }
                                    }
                                }
                            });
                        }
                        //$scope.map.fitBounds($scope.routeReal[keyRoute].getBounds());
                    }
                }
            }
        }

        $scope.loadRouteReal = function(slot, mode) {
            if (!angular.isUndefined($scope.center_marker)) {
                $scope.map.removeLayer($scope.center_marker);
            }
            $scope.waypoints = [];

            if (!angular.isUndefined(slot['routes'])) {
                if (slot['routes'] && slot['routes'].length > 0) {

                    let latlngs = [];
                    if(mode && mode == 'all') {
                        angular.forEach(slot['routes'], function (itemRoute, keyRoute) {
                            latlngs[keyRoute] = [slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude']];
                            $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date']);

                            //latlngs= [["46.7712", "23.6236"], ["46.7312", "23.6136"]];//for snake effect

                            if(keyRoute == 0){
                                latlngs[keyRoute] = [slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude']];
                                latlngs[1] = [slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude']];
                            }

                            $scope.routeReal[keyRoute] = L.polyline(latlngs, {color: '#' + $scope.color_driver, weight: 5, opacity: 0.74});
                            if (($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 0) || ($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 1))  {
                                //→  ► >
                                $scope.routeReal[keyRoute].setText('   →   ', {
                                    repeat: true,
                                    attributes: {
                                        fill: '404040',
                                        'font-weight': 'bold',
                                        'font-size': '18'
                                    }
                                });
                                $scope.routeReal[keyRoute].addTo($scope.map).snakeIn();

                            }
                            if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 1) {
                                //→  ► >
                                $scope.routeReal[keyRoute].setText('   →   ', {
                                    repeat: true,
                                    attributes: {
                                        fill: '404040',
                                        'font-weight': 'bold',
                                        'font-size': '18'
                                    }
                                });
                                $scope.routeReal[keyRoute].addTo($scope.map);
                            }
                            if ($rootScope.settings.enable_route_animation == 0 && $rootScope.settings.enable_direction_animation == 0) {
                                $scope.routeReal[keyRoute].addTo($scope.map);
                            }
                            //$scope.map.fitBounds($scope.routeReal[keyRoute].getBounds());

                        });
                    } else {
                        if (!angular.isUndefined(slot['routes'][1])) {
                            latlngs = [
                                [slot['routes'][0]['driver_latitude'], slot['routes'][0]['driver_longitude']],
                                [slot['routes'][1]['driver_latitude'], slot['routes'][1]['driver_longitude']]
                            ];
                        } else {
                            latlngs = [
                                [slot['routes'][0]['driver_latitude'], slot['routes'][0]['driver_longitude']],
                                [slot['routes'][0]['driver_latitude'], slot['routes'][0]['driver_longitude']]
                            ];
                        }
                        $scope.addDriverPoint(slot['routes'][0]['driver_latitude'], slot['routes'][0]['driver_longitude']);

                        var len = $scope.routeReal.length;
                        $scope.routeReal[len] = L.polyline(latlngs, {color: '#' + $scope.color_driver, weight: 5, opacity: 0.5});
                        $scope.routeReal[len].addTo($scope.map);
                        //$scope.map.fitBounds($scope.routeReal[len].getBounds());
                    }


                }
            }
        }

        $scope.removeRouteReal = function() {
            //console.log($scope.routeReal)
            if ($scope.routeReal.length > 0) {
                angular.forEach($scope.routeReal, function (itemRouteReal, keyRouteReal) {
                    if (!angular.isUndefined($scope.routeReal[keyRouteReal])) {
                      //$scope.map.removeLayer($scope.routeReal[keyRouteReal]);
                      angular.forEach($scope.routeReal[keyRouteReal], function (itemRouteRealSegment, keyRouteRealSegment) {
                          $scope.map.removeLayer($scope.routeReal[keyRouteReal][keyRouteRealSegment]);
                      });
                    }
                });
            }
            if ($scope.driver_points.length > 0) {
                angular.forEach($scope.driver_points, function (itemPoint, keyPoint) {
                    if (!angular.isUndefined($scope.driver_points[keyPoint])) {
                        $scope.map.removeLayer($scope.driver_points[keyPoint]);
                    }
                });
                $scope.driver_points = [];
            }
        }

        if ($scope.state.view == 'drivers') {
            $scope.cancel();
        }

        $scope.changeView = function () {
            if ($scope.state.view == 'drivers') {
                angular.element(document.querySelector('.expand-drivers-return')).css('top', '12%');
                angular.element(document.querySelector('.full-screen .expand-drivers-return')).css('top', '7%');
                angular.element(document.querySelector('#map-canvas')).css('height', 'calc(155vh - 0px)');
                $scope.map.invalidateSize();
                $scope.map._onResize();
                $scope.cancel();
                angular.forEach($scope.driver_marker, function (item, key) {
                    if (!angular.isUndefined($scope.driver_marker[key]) && $scope.driver_marker[key] != null) {
                        //$scope.driver_marker[key].setLatLng([0, 0]);
                        $scope.driver_marker[key].setOpacity(1);
                        $scope.driver_marker[key].openTooltip();
                    }
                });
            } else {

                $scope.maxDate = new Date();
                $scope.minDate = '2010-01-01';
                var current_init_date = new Date();
                current_init_date.setHours(4,0,0,0);
                //var current_init_date = new Date('2024-03-18');
                //current_init_date.setHours(21,3,0,0);

                var compare_date = new Date();
                compare_date.setHours(4,0,0,0);
                if(!$scope.additionals['compareDates'](new Date(), compare_date)) {
                    current_init_date.setDate(current_init_date.getDate() - 1);
                }
                $scope.search.dateFrom = current_init_date;
                //$scope.search.dateFrom = '2019-02-10T00:00:00Z';
                $scope.search.timeFrom = current_init_date;

                var current_end_date = new Date();
                current_end_date.setHours(3,59,59,0);
                //current_end_date.setHours(22,59,0,0);
                if($scope.additionals['compareDates'](new Date(), compare_date)) {
                    current_end_date.setDate(current_end_date.getDate() + 1);
                }
                $scope.search.dateTo = current_end_date;
                $scope.search.timeTo = current_end_date;

                if ($scope.state.view == 'routes' && (angular.isUndefined($scope.search['driver_id']) || $scope.search['driver_id'] == null)) {
                    if (!angular.isUndefined($scope.additionals['drivers'][0])) {
                        $scope.search['driver_id'] = $scope.additionals['drivers'][0]['id'];
                        $scope.search['id'] = null;
                    }
                }
                //if ((!angular.isUndefined($scope.search['dateFrom']) && $scope.search['dateFrom'] != null) || (!angular.isUndefined($scope.search['dateTo']) && $scope.search['dateTo'] != null)) {
                    //$scope.getSlotsDriver();
                    $scope.waypoints = [];
                    $scope.removeRouteReal();
                    $scope.setCenter();

                    angular.forEach($scope.driver_marker, function (item, key) {
                        if($scope.slotModel['driver_id'] != parseInt(key)) {
                            if (!angular.isUndefined($scope.driver_marker[key]) && $scope.driver_marker[key] != null) {
                                $scope.driver_marker[key].setOpacity(0);
                                $scope.driver_marker[key].closeTooltip();
                            }
                        }
                    });

                //}

                setTimeout( function() {
                    var heightFormSearch = $('#search-form').height() - 50;
                    if ($route.current.$$route.originalPath != '/slot/mapFullscreen') {
                        angular.element(document.querySelector('.expand-drivers-return')).css('top', document.querySelector('.expand-drivers-return').getBoundingClientRect().top + heightFormSearch - 60 +'px');
                    } else {
                        angular.element(document.querySelector('.expand-drivers-return')).css('top', document.querySelector('.expand-drivers-return').getBoundingClientRect().top + heightFormSearch +'px');
                    }
                    angular.element(document.querySelector('#map-canvas')).css('height', $('#map-canvas').height() + heightFormSearch +'px');
                    $scope.map.invalidateSize();
                    $scope.map._onResize();
                }, 100);


            }
        }

        $scope.viewEstimatedRoute = function (slot) {
            if($scope.routesControl) {
                if ($scope.routesControl['route_estimated'] == true) {
                    $scope.loadRouteEstimated(slot);
                } else {
                    $scope.removeRouteEstimated();
                }
            }
        }

        $scope.limit = 100;
        $scope.offset = 0;
        $scope.dataRoute = {};
        $scope.dataRoute.routes = [];
        $scope.no_markers = 0;
        $scope.end_point = 0;
        var canceler = $q.defer();
        $scope.stopLoadRoute = function () {
              $scope.dataRoute = {};
              $scope.dataRoute.routes = [];
              $scope.no_markers = 0;
              $scope.end_point = 0;
              $scope.offset = 0;
              $scope.waypoints = [];
              $scope.removeRouteReal();
              $scope.setCenter();

              $scope.isLoading = false;
              $scope.additionals['buttonDisabledSearch'] = false;
              canceler.resolve("cancelled");
              canceler = $q.defer();
        }

        $scope.getRouteByDriver = function (off) {
            if (!angular.isUndefined(off)) {
                $scope.dataRoute = {};
                $scope.dataRoute.routes = [];
                $scope.no_markers = 0;
                $scope.end_point = 0;
                $scope.offset = 0;
                $scope.waypoints = [];
                $scope.removeRouteReal();
                $scope.setCenter();
            }
            if (!angular.isUndefined($scope.search.driver_id) && $scope.search.driver_id != 0) {

                $scope.isLoading = true;
                var post = $scope.search;
                post['route'] = 'getRouteByDriver';
                post['offset'] = $scope.offset;
                post['limit'] = $scope.limit;
                $scope.additionals['buttonDisabledSearch'] = true;

                canceler.resolve("cancelled");
                canceler = $q.defer();
                Crud.post($scope.additionals['content_type'], post, $scope.path + '/getRouteByDriver', canceler)
                    .success(function (data) {
                        $scope.isLoading = false;
                        $scope.additionals['buttonDisabledSearch'] = false;

                        angular.forEach($scope.driver_marker, function (item, key) {
                            if ($scope.slotModel['driver_id'] != parseInt(key)) {
                                if (!angular.isUndefined($scope.driver_marker[key]) && $scope.driver_marker[key] != null) {
                                    $scope.driver_marker[key].setOpacity(0);
                                    $scope.driver_marker[key].closeTooltip();
                                }
                            }
                        });
                        //$scope.loadRouteReal(data, 'all');
                        /*if($scope.offset == 0){
                            $scope.dataRoute.routes = data['routes'];
                        } else {
                            data['routes'].unshift($scope.dataRoute['routes'][$scope.dataRoute['routes'].length - 1]);
                            $scope.dataRoute.routes = data['routes'];
                        }*/
                        /*data['routes'].unshift($scope.dataRoute['routes'][$scope.dataRoute['routes'].length - 1]);
                        $scope.dataRoute.routes = data['routes'];*/

                        $scope.no_markers = $scope.no_markers + data['no_markers'];
                        if($scope.offset == 0){
                            $scope.dataRoute.routes = data['routes'];
                        } else {
                            $scope.dataRoute.routes = [$scope.dataRoute['routes'][$scope.dataRoute['routes'].length - 1]].concat(data['routes']);
                            //$scope.dataRoute.routes = data['routes'];
                        }

                        $scope.offset = $scope.offset + $scope.limit;
                        if (($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 0) || ($rootScope.settings.enable_route_animation == 1 && $rootScope.settings.enable_direction_animation == 1)) {
                            if(data['routes'].length == $scope.limit) {
                            } else {
                                $scope.end_point = 1;
                            }
                        } else {
                            if(data['routes'].length == $scope.limit) {
                                $scope.getRouteByDriver();
                            } else {
                                $scope.end_point = 1;
                            }
                        }
                        $scope.loadRouteRealy($scope.dataRoute, 'all', $scope.offset/$scope.limit);
                    });
            }
        }

        $scope.getRoute = function (slot_id) {
            var post = {};
            post['route'] = 'getRoute';
            post['slot_id'] = slot_id;

            Crud.post($scope.additionals['content_type'], post, $scope.path+'/getRoute')
                .success(function (data) {
                    $scope.loadRouteReal(data, 'all');
                });
        }

        $scope.viewRealRoute = function (slot) {
            if($scope.routesControl) {
                if ($scope.routesControl['route_real'] == true) {
                    $scope.getRoute(slot.id);
                } else {
                    $scope.removeRouteReal();
                }
            }
        }


    }]
);
